import { memo, useCallback } from 'react';
import { cn } from '@divlab/divanui';
import { IconCross } from '@divlab/divanui/icons';

import Link from '@Navigation/Link';
import Preview from './elems/Preview';
import Footer from './elems/Footer';
import styles from './RelatedProductCard.module.css';

import type { ProductData } from '@Types/Product';
import type { FC, HTMLAttributes } from 'react';

interface RelatedProductCardProps extends HTMLAttributes<HTMLDivElement> {
  product: ProductData;
  position: number;
  onChangeQuantity?(product: ProductData, quantity: number, position: number): void;
}

const RelatedProductCard: FC<RelatedProductCardProps> = (props) => {
  const { className, product, position, onChangeQuantity, ...restProps } = props;

  const handleRemove = useCallback(() => {
    onChangeQuantity?.(product, 0, position);
  }, [onChangeQuantity, position, product]);

  return (
    <div {...restProps} className={cn(styles.card, className)}>
      <div className={styles.wrapper}>
        <Preview className={styles.preview} product={product} position={position} />

        <div className={styles.content}>
          <Link to={product.link} className={styles.name} view='primary' target='_blank'>
            {`${product.type} ${product.name}`}
          </Link>

          <div className={styles.contentFooter}>
            <Footer
              className={styles.footer}
              product={product}
              position={position}
              onChangeQuantity={onChangeQuantity}
            />
          </div>
        </div>
        <IconCross className={styles.iconClose} onClick={handleRemove} />
      </div>

      <div className={styles.mainFooter}>
        <Footer
          className={styles.footer}
          product={product}
          position={position}
          onChangeQuantity={onChangeQuantity}
        />
      </div>
    </div>
  );
};

export default memo(RelatedProductCard);
